import colors from 'styles/colors'

const styles = {
  date: {
    color: colors.darkStormy,
    fontFamily: 'Barlow',
    fontSize: 18,
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: 5
  },
  address: {
    color: colors.darkGreen,
    fontFamily: 'Barlow',
    fontSize: 18,
    textAlign: 'center',
    letterSpacing: 0.12,
    marginBottom: 45
  }
}

export default styles
